import { connect } from 'react-redux';

type mapStateToPropsType = (state: any) => any;

const mapDispatchToProps = (dispatch) => ({ dispatch });

const withConnect = (mapStateToProps: mapStateToPropsType = () => ({})) => connect(mapStateToProps, mapDispatchToProps);

export default withConnect;
